// adminRoutes.js
import { layout } from 'echarts/lib/layout/barGrid'
import { name } from 'file-loader'

const Layout = () => import('@/views/layout/Layout.vue')
export default [
  {
    path: '/pms',
    component: Layout,
    redirect: '/pms/product',
    name: 'pms',
    meta: { title: '商城管理', icon: 'el-icon-shopping-cart-2' },
    children: [{
      path: 'product',
      name: 'product',
      component: () => import('@/views/pms/product/index'),
      meta: { title: '商品列表', icon: 'el-icon-menu' }
    },
    {
      path: 'advertisement',
      name: 'advertisement',
      component: () => import('@/views/pms/advertisement/advertisement'),
      meta: { title: '广告商品', icon: 'el-icon-picture-outline' }
    },
    {
      path: 'addProduct',
      name: 'addProduct',
      component: () => import('@/views/pms/product/add'),
      meta: { title: '添加商品', icon: 'el-icon-circle-plus' }
    },
    {
      path: 'updateProduct',
      name: 'updateProduct',
      component: () => import('@/views/pms/product/update'),
      meta: { title: '修改商品', icon: 'el-icon-edit' },
      hidden: true
    },
    {
      path: 'detailProduct',
      name: 'detailProduct',
      component: () => import('@/views/pms/product/detail'),
      meta: { title: '查看商品', icon: 'el-icon-view' },
      hidden: true
    },
    {
      path: 'productCate',
      name: 'productCate',
      component: () => import('@/views/pms/productCate/index'),
      meta: { title: '商品分类', icon: 'el-icon-folder' }
    },
    {
      path: 'order',
      name: 'order',
      component: () => import('@/views/order/index'),
      meta: { title: '订单管理', icon: 'el-icon-s-order' }
    },
    {
      path: 'afterSale',
      name: 'afterSale',
      component: () => import('@/views/order/afterSale'),
      meta: { title: '退货订单', icon: 'el-icon-s-order' }
    },
    {
      path: 'threasion',
      name: 'threasion',
      component: () => import('@/views/order/orderSeting/threasion'),
      meta: { title: '退货原因', icon: 'el-icon-warning-outline' },
      hidden: true
    },
    {
      path: 'kdmodle',
      name: 'kdmodle',
      component: () => import('@/views/order/orderSeting/kdmodle'),
      meta: { title: '快递单模版', icon: 'el-icon-document' },
      hidden: true
    },
    {
      path: 'thAddres',
      name: 'thAddres',
      component: () => import('@/views/order/orderSeting/thaddres'),
      meta: { title: '收货地址', icon: 'el-icon-location-information' },
      hidden: true
    },
    {
      path: 'addProductCate',
      name: 'addProductCate',
      component: () => import('@/views/pms/productCate/add'),
      meta: { title: '添加商品分类', icon: 'el-icon-circle-plus' },
      hidden: true
    },
    {
      path: 'updateProductCate',
      name: 'updateProductCate',
      component: () => import('@/views/pms/productCate/update'),
      meta: { title: '修改商品分类', icon: 'el-icon-edit' },
      hidden: true
    },
    {
      path: 'productAttrList',
      name: 'productAttrList',
      component: () => import('@/views/pms/productAttr/productAttrList'),
      meta: { title: '商品属性列表', icon: 'el-icon-menu' },
      hidden: true
    },
    {
      path: 'addProductAttr',
      name: 'addProductAttr',
      component: () => import('@/views/pms/productAttr/addProductAttr'),
      meta: { title: '添加商品属性', icon: 'el-icon-circle-plus' },
      hidden: true
    },
    {
      path: 'updateProductAttr',
      name: 'updateProductAttr',
      component: () => import('@/views/pms/productAttr/updateProductAttr'),
      meta: { title: '修改商品属性', icon: 'el-icon-edit' },
      hidden: true
    },
    {
      path: 'addBrand',
      name: 'addBrand',
      component: () => import('@/views/pms/brand/add'),
      meta: { title: '添加品牌', icon: 'el-icon-circle-plus' },
      hidden: true
    },
    {
      path: 'updateBrand',
      name: 'updateBrand',
      component: () => import('@/views/pms/brand/update'),
      meta: { title: '编辑品牌', icon: 'el-icon-edit' },
      hidden: true
    }
    ]
  },
  {
    path: '/landControl',
    component: Layout,
    redirect: '/landControl/land',
    name: 'landControl',
    meta: { title: '共享农田', icon: 'el-icon-office-building' },
    children: [{
      path: 'land',
      name: 'land',
      component: () => import('@/views/landControl/land'),
      meta: { title: '土地列表', icon: 'el-icon-menu' }
    },
    {
      path: 'landCreate',
      name: 'landCreate',
      component: () => import('@/views/landControl/landCreate'),
      meta: { title: '创建土地', icon: 'el-icon-circle-plus' }
    },
    {
      path: 'landOrder',
      name: 'landOrder',
      component: () => import('@/views/landControl/landOrder'),
      meta: { title: '土地订单', icon: 'el-icon-s-order' }
    }
    ]
  },
  {
    path: '/gms',
    redirect: '/gms/gameProduct',
    name: 'gms',
    component: Layout,
    meta: { title: '云耕游戏', icon: 'el-icon-monitor' },
    children: [{
      path: 'gameProduct',
      name: 'gameProduct',
      component: () => import('@/views/gms/gameProduct'),
      meta: { title: '云耕商城', icon: 'el-icon-shopping-cart-2' }
    }]
  },
  {
    path: '/retail',
    component: Layout,
    redirect: '/retail/retail',
    name: 'retailManagement',
    meta: { title: '共富商户', icon: 'el-icon-s-shop' },
    children: [{
      path: 'retail',
      name: 'retail',
      component: () => import('@/views/retail/retail'),
      meta: { title: '共富农户', icon: 'el-icon-user' }
    },{
      path: 'retailOrder',
      name: 'retailOrder',
      component: () => import('@/views/retail/order'),
      meta: { title: '农户订单', icon: 'el-icon-user' }
    }, {
      path: 'retailProduct',
      name: 'retailProduct',
      component: () => import('@/views/retail/retailProduct'),
      meta: { title: '商品创建', icon: 'el-icon-circle-plus' }
    }, {
      path: 'retailProductDetail',
      name: 'retailProductDetail',
      component: () => import('@/views/retail/retailProductDetail'),
      meta: { title: '商品列表', icon: 'el-icon-menu' },
      hidden: true
    }
    ]
  },
  {
    path: '/lives',
    component: Layout,
    redirect: '/lives/liveProduct',
    name: 'livesManagement',
    meta: { title: '生活馆', icon: 'el-icon-house' },
    children: [{
      path: 'liveProduct',
      name: 'liveProduct',
      component: () => import('@/views/lives/liveProduct'),
      meta: { title: '馆内商品', icon: 'el-icon-goods' }
    }, {
      path: 'addProduct',
      name: 'livesAddProduct',
      component: () => import('@/views/lives/addProduct'),
      meta: { title: '商品创建', icon: 'el-icon-circle-plus' }
    },{
      path: 'lifeHallImg',
      name: 'lifeHallImg',
      component: () => import('@/views/lives/lifeHallImg'),
      meta: { title: '生活馆图片', icon: 'el-icon-circle-plus' }
    }
    ]
  },
  {
    path: '/prize',
    component: Layout,
    redirect: '/prize/prize',
    name: 'prizeManagement',
    meta: { title: '签到有礼', icon: 'el-icon-gift' },
    children: [{
      path: 'prizeCreate',
      name: 'prizeCreate',
      component: () => import('@/views/prize/prizeCreate'),
      meta: { title: '添加礼品', icon: 'el-icon-circle-plus' }
    }, {
      path: 'prize',
      name: 'prize',
      component: () => import('@/views/prize/prize'),
      meta: { title: '礼品列表', icon: 'el-icon-menu' }
    }, {
      path: 'prizeRecord',
      name: 'prizeRecord',
      component: () => import('@/views/prize/prizeRecord'),
      meta: { title: '领奖记录', icon: 'el-icon-tickets' }
    }
    ]
  },
  {
    path: '/hotel',
    component: Layout,
    redirect: '/hotel/hotel',
    name: 'hotelManagement',
    meta: { title: '酒店管理', icon: 'el-icon-office-building' },
    children: [{
      path: 'hotel',
      name: 'hotel',
      component: () => import('@/views/hotel/hotel'),
      meta: { title: '酒店列表', icon: 'el-icon-menu' }
    }, {
      path: 'hotelCreate',
      name: 'hotelCreate',
      component: () => import('@/views/hotel/hotelCreate'),
      meta: { title: '创建酒店', icon: 'el-icon-circle-plus' }
    }
    ]
  },
  {
    path: '/venue',
    component: Layout,
    redirect: '/venue/venue',
    name: 'venueManagement',
    meta: { title: '场地管理', icon: 'el-icon-place' },
    children: [{
      path: 'venue',
      name: 'venue',
      component: () => import('@/views/venue/venue'),
      meta: { title: '场地列表', icon: 'el-icon-menu' }
    },
    {
      path: 'venueRecord',
      name: 'venueRecord',
      component: () => import('@/views/venue/venueRecord'),
      meta: { title: '预约记录', icon: 'el-icon-tickets' }
    }
    ]
  },
  {
    path: '/writeOff',
    component: Layout,
    redirect: '/writeOff/offGoods',
    name: 'writeOff',
    meta: { title: '核销管理', icon: 'el-icon-thumb' },
    children: [{
      path: 'offGoods',
      name: 'offGoods',
      component: () => import('@/views/writeOff/offGoods/index'),
      meta: { title: '核销商品管理', icon: 'el-icon-goods' }
    },
    {
      path: 'addOff',
      name: 'addOff',
      component: () => import('@/views/writeOff/offGoods/addOff'),
      meta: { title: '添加核销商品', icon: 'el-icon-circle-plus' },
      hidden: true
    },
    {
      path: 'offOrder',
      name: 'offOrder',
      component: () => import('@/views/writeOff/offOrder/index'),
      meta: { title: '核销订单管理', icon: 'el-icon-s-order' }
    }
    ]
  },
  {
    path: '/member',
    component: Layout,
    redirect: '/member/memberList',
    name: 'member',
    meta: { title: '会员管理', icon: 'el-icon-user' },
    children: [{
      path: 'memberList',
      name: 'memberList',
      component: () => import('@/views/memberManagement/menberList/index'),
      meta: { title: '会员列表', icon: 'el-icon-menu' }
    },
    {
      path: 'memberShip',
      name: 'memberShip',
      component: () => import('@/views/memberManagement/memberShip/index'),
      meta: { title: '会员套餐', icon: 'el-icon-box' }
    },
    {
      path: 'addShip',
      name: 'addShip',
      component: () => import('@/views/memberManagement/memberShip/addShip'),
      meta: { title: '添加套餐', icon: 'el-icon-circle-plus' },
      hidden: true
    },
    {
      path: 'adMember',
      name: 'adMember',
      component: () => import('@/views/memberManagement/adMember/index'),
      meta: { title: '会员广告', icon: 'el-icon-circle-plus' },
      hidden: false
    },
    {
      path: 'editShip',
      name: 'editShip',
      component: () => import('@/views/memberManagement/memberShip/editShip'),
      meta: { title: '编辑套餐', icon: 'el-icon-edit' },
      hidden: true
    }
    ]
  },
  {
    path: '/activity',
    component: Layout,
    redirect: '/activity/activityList',
    name: 'activity',
    meta: { title: '活动管理', icon: 'el-icon-star-off' },
    children: [{
      path: 'activityList',
      name: 'activityList',
      component: () => import('@/views/activity/activityList/index'),
      meta: { title: '活动列表', icon: 'el-icon-menu' }
    },
    {
      path: 'addActive',
      name: 'addActive',
      component: () => import('@/views/activity/activityList/addActive'),
      meta: { title: '新建活动', icon: 'el-icon-circle-plus' },
      hidden: true
    },
    {
      path: 'detailActive',
      name: 'detailActive',
      component: () => import('@/views/activity/activityList/detailActive'),
      meta: { title: '活动详情', icon: 'el-icon-view' },
      hidden: true
    },
    {
      path: 'editlActive',
      name: 'editlActive',
      component: () => import('@/views/activity/activityList/editActive'),
      meta: { title: '编辑活动', icon: 'el-icon-edit' },
      hidden: true
    }, {
      path: 'activityType',
      name: 'activityType',
      component: () => import('@/views/activity/activityList/activityType'),
      meta: { title: '活动类型管理', icon: 'el-icon-folder' }
    }
    ]
  },
  {
    path: '/coupon',
    component: Layout,
    redirect: '/coupon/couponList',
    name: 'coupon',
    meta: { title: '优惠券管理', icon: 'el-icon-ticket' },
    children: [{
      path: 'couponList',
      name: 'couponList',
      component: () => import('@/views/couponManagement/couponList/index'),
      meta: { title: '优惠券列表', icon: 'el-icon-menu' }
    },
    {
      path: 'couponPackage',
      name: 'couponPackage',
      component: () => import('@/views/couponManagement/couponList/couponPackage'),
      meta: { title: '优惠券包', icon: 'el-icon-menu' }
    },
    {
      path: 'addCoupon',
      name: 'addCoupon',
      component: () => import('@/views/couponManagement/couponList/addCoupon'),
      meta: { title: '添加优惠券', icon: 'el-icon-circle-plus' },
      hidden: true,
    },
    {
      path: 'editCoupon',
      name: 'editCoupon',
      component: () => import('@/views/couponManagement/couponList/editCoupon'),
      meta: { title: '编辑优惠券', icon: 'el-icon-edit' },
      hidden: true,
    },
    {
      path: 'detailCoupon',
      name: 'detailCoupon',
      component: () => import('@/views/couponManagement/couponList/detailCoupon'),
      meta: { title: '优惠券详情', icon: 'el-icon-view' },
      hidden: true,
    }
    ]
  },
  {
    path: '/comprehensive',
    component: Layout,
    redirect: '/comprehensive/dynamic',
    name: 'comprehensive',
    meta: { title: '综合管理', icon: 'el-icon-setting' },
    children: [{
      path: 'area',
      name: 'area',
      component: () => import('@/views/comprehensive/area/area'),
      meta: { title: '景区管理', icon: 'el-icon-place' }
    }, {
      path: 'dynamic',
      name: 'dynamic',
      component: () => import('@/views/comprehensive/dynamics/index'),
      meta: { title: '动态管理', icon: 'el-icon-news' }  , 
      hidden:true
    },
    {
      path: 'addpub',
      name: 'addpub',
      component: () => import('@/views/comprehensive/dynamics/addPublish'),
      meta: { title: '新增动态', icon: 'el-icon-circle-plus' },
      hidden: true
    },
    {
      path: 'editpub',
      name: 'editpub',
      component: () => import('@/views/comprehensive/dynamics/editPublish'),
      meta: { title: '编辑动态', icon: 'el-icon-edit' },
      hidden: true
    },
    {
      path: 'message',
      name: 'message',
      component: () => import('@/views/comprehensive/messagePush/index'),
      meta: { title: '消息推送', icon: 'el-icon-message' },
      hidden: true
    },
    {
      path: 'addMessage',
      name: 'addMessage',
      component: () => import('@/views/comprehensive/messagePush/addMessage'),
      meta: { title: '新增推送', icon: 'el-icon-circle-plus' },
      hidden: true
    },
    {
      path: 'feedList',
      name: 'feedList',
      component: () => import('@/views/comprehensive/feedBack/feedList'),
      meta: { title: '意见反馈', icon: 'el-icon-chat-line-square' },
    }
    ]
  },
  {
    path: '/system',
    component: Layout,
    redirect: '/system/salesperson',
    name: 'system',
    meta: { title: '系统管理', icon: 'el-icon-s-tools' },
    children: [{
      path: 'salesperson',
      name: 'salesperson',
      component: () => import('@/views/system/Salesperson/index'),
      meta: { title: '业务员管理', icon: 'el-icon-user' }
    },

    {
      path: 'addSperson',
      name: 'addSperson',
      component: () => import('@/views/system/Salesperson/addSperson'),
      meta: { title: '新增业务员', icon: 'el-icon-circle-plus' },
      hidden: true
    },
    {
      path: 'detailSperson',
      name: 'detailSperson',
      component: () => import('@/views/system/Salesperson/detailSperson'),
      meta: { title: '业务员详情', icon: 'el-icon-view' },
      hidden: true
    },
    {
      path: 'giftRoll',
      name: 'giftRoll',
      component: () => import('@/views/system/Salesperson/giftRoll'),
      meta: { title: '业务员详情', icon: 'el-icon-view' },
      hidden: true
    },
    {
      path: 'merchant',
      name: 'merchant',
      component: () => import('@/views/system/merchant/index'),
      meta: { title: '商家管理', icon: 'el-icon-s-shop' }
    },
    {
      path: 'addMerchant',
      name: 'addMerchant',
      component: () => import('@/views/system/merchant/addMerchant'),
      meta: { title: '新增商家', icon: 'el-icon-circle-plus' },
      hidden: true
    },
    {
      path: 'detailMerchant',
      name: 'detailMerchant',
      component: () => import('@/views/system/merchant/detailMerchant'),
      meta: { title: '商家详情', icon: 'el-icon-view' },
      hidden: true
    }, {
      path: 'accountNumber',
      name: 'accountNumber',
      component: () => import('@/views/system/accountNumber/index'),
      meta: { title: '平台账号管理', icon: 'el-icon-s-custom' },
      hidden: true
    },
    {
      path: 'addAcountNumber',
      name: 'addAcountNumber',
      component: () => import('@/views/system/accountNumber/addAcount'),
      meta: { title: '新增账号', icon: 'el-icon-circle-plus' },
      hidden: true
    },
    {
      path: 'detailAcountNumber',
      name: 'detailAcountNumber',
      component: () => import('@/views/system/accountNumber/detailAcount'),
      meta: { title: '账号详情', icon: 'el-icon-view' },
      hidden: true
    }
    ]
  },
]


// WEBPACK FOOTER //
// ./src/router/adminRoutes.js